var debug = false;
//debug = true;

window.addEventListener("load", function () {
  core();
});

$(function () {
  // Language switcher event listener
  $(document).on("click", ".change-lang", function (e) {
    e.preventDefault();
    var selectedLang = $(this).data("lang"); // Get the selected language from dropdown
    if ($(this).attr("data-user-id") !== undefined) {
      updateUserLanguage(
        $(this).attr("data-user-type"),
        $(this).attr("data-user-id"),
        selectedLang
      );
    } else {
      changeLanguage(selectedLang); // Call the function to change language
    }
  });
  tableInit();
  handleOTPInputs();
});

// =========================================
// CORE METHODS
// =========================================

function core() {
  // Initialize AJAX form submission handling
  form_submit();

  // Initialize modal automation for loading modal content dynamically
  modalAutomation();
}

// =========================================
// LANGUAGE METHODS
// =========================================
// Function to update the language in the URL
function changeLanguage(newLang) {
  var debug = false; // Enable or disable debug mode here

  // Function to handle logging if debug mode is enabled
  function logDebug(...args) {
    if (debug) {
      console.log(...args);
    }
  }

  logDebug("v2");
  var currentUrl = window.location.href; // Get the current URL
  var appUrl = $("html").data("app-url"); // Base URL stored in a data attribute
  var defaultLang = $("html").data("default-lang"); // Default language

  logDebug({ currentUrl, appUrl, defaultLang, newLang });

  // Ensure the app URL has no trailing slash
  appUrl = appUrl.replace(/\/$/, "");

  // Extract the main domain (ignoring subdomains)
  var mainDomain = appUrl.replace(/^https?:\/\/(www\.)?/, "");
  logDebug({ mainDomain });

  // Regex to detect a language code in the URL (handles query params and non-language-prefixed URLs)
  var langRegex = new RegExp("(https?://[^/]+)/(\\w{2})(/|$)", "i");
  logDebug({ langRegex });
  var newUrl;

  // Check if the URL contains a language code
  if (currentUrl.match(langRegex)) {
    logDebug("URL contains a language code");
    // If the language code is already in the URL
    if (newLang === defaultLang) {
      // If the selected language is the default one, remove the language code
      newUrl = currentUrl.replace(langRegex, "$1$3");
    } else {
      // Replace the current language code with the new one
      newUrl = currentUrl.replace(langRegex, "$1/" + newLang + "$3");
    }
  } else {
    logDebug("No language code is found in the URL");
    // If no language code is found in the URL
    if (newLang !== defaultLang) {
      logDebug("Selected language is not the default");
      // If the selected language is not the default, add the language code to the URL after the domain
      newUrl = currentUrl.replace(/(https?:\/\/[^\/]+)(\/)?/, `$1/${newLang}/`);
    } else {
      logDebug("Selected language is the default");
      // If the selected language is the default, leave the URL as it is
      newUrl = currentUrl;
    }
  }

  logDebug({ newUrl });
  // Redirect the user to the new URL
  window.location.href = newUrl;
}

function updateUserLanguage(user_type, user_id, language) {
  $.ajax({
    async: false,
    type: "POST",
    url: "/userManagementController/veriUserUpdate",
    data: { user_type: user_type, id: user_id, language: language },
    beforeSend: function () {
      showLoader();
    },
    success: function (response) {
      hideLoader();

      try {
        var data = JSON.parse(response);
      } catch (error) {
        debug && console.error("Invalid JSON response:", error);
        return;
      }
      changeLanguage(language);
    },
  });
}

// =========================================
// MODAL AUTOMATION
// =========================================

function modalAutomation() {
  // If the URL contains a modal hash, open the corresponding modal and load content
  if (window.location.hash.substring(1, 14) === "general_modal") {
    var modal_size = window.location.hash.substring(1, 17);
    var target = {};
    target.link = window.location.hash.substring(17);
    var modal = $("#" + modal_size);
    modal.modal("show");

    loadModal(modal, target);
  }

  // Event to load content into a modal when shown
  $(document).on("show.bs.modal", ".general_modal", function (e) {
    var target = $(e.relatedTarget);
    target.link = target.data("link");
    var modal = $(target.data("bs-target"));

    if (typeof target != "undefined") {
      window.location.hash = target.data("bs-target") + target.link;
    }

    loadModal(modal, target);
  });

  // Event to reset modal content when hidden
  $(document).on("hidden.bs.modal", ".general_modal", function () {
    $(".general_modal .modal-content").html(
      '<div class="text-center m-5"><i class="fas fa-circle-notch fa-spin fa-5x"></i></div>'
    );
    history.replaceState(null, null, " ");
  });
}

function loadModal(modal, target) {
  console.log(modal, target);
  modal.find(".modal-content").load(target.link, function () {
    $(document).off("focusin.modal");
    // Initialize Bootstrap components after the content is loaded
    setTimeout(function () {
      initializeBootstrapComponents();
      initMain();
    }, 200);
  });
}

// Function to initialize all Bootstrap components
function initializeBootstrapComponents() {
  // Initialize tooltips
  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });

  // Initialize popovers
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl);
  });

  // Initialize tabs
  var tabTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tab"]')
  );
  var tabList = tabTriggerList.map(function (tabTriggerEl) {
    return new bootstrap.Tab(tabTriggerEl);
  });

  // Initialize dropdowns
  var dropdownTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="dropdown"]')
  );
  var dropdownList = dropdownTriggerList.map(function (dropdownTriggerEl) {
    return new bootstrap.Dropdown(dropdownTriggerEl);
  });

  // Initialize collapses
  var collapseTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="collapse"]')
  );
  var collapseList = collapseTriggerList.map(function (collapseTriggerEl) {
    return new bootstrap.Collapse(collapseTriggerEl);
  });

  // Initialize carousels
  var carouselTriggerList = [].slice.call(
    document.querySelectorAll(".carousel")
  );
  var carouselList = carouselTriggerList.map(function (carouselEl) {
    return new bootstrap.Carousel(carouselEl);
  });
}

function initTooltipIcons() {
  $(".tooltip-icons").each(function () {
    new bootstrap.Tooltip(this);
  });
}

// =========================================
// LOADER METHODS
// =========================================

// Function to show the loader overlay and spinner
function showLoader() {
  $("#loader_overlay").fadeIn("slow");
  $("#loader_spin").fadeIn("slow");
}

// Function to hide the loader overlay and spinner
function hideLoader() {
  $("#loader_overlay").fadeOut("slow");
  $("#loader_spin").fadeOut("slow");
}

// =========================================
// DATA TABLE METHODS
// =========================================

function tableInit() {
  $(".dt-general").each(function () {
    var current_table = $(this);
    // Check if DataTable is already initialized
    if (!$.fn.DataTable.isDataTable(current_table)) {
      showLoader();
      var source = $(current_table).data("source");
      var db_table = $(current_table).data("table");
      var addon = $(current_table).data("addon");
      var def_search = $(current_table).data("table-def-search");
      var table_from = $("#table_from").val();
      var table_to = $("#table_to").val();
      var colvis_text = $(this).data("colvis");
      var lang_code = $("html").attr("lang");

      var columns = [];
      var defaultOrder = []; // To store the default order

      // Add a new row for column search inputs below the header
      $(current_table).find("thead").append('<tr class="search-row"></tr>');

      // Loop through each th in thead
      $("th", current_table).each(function (index) {
        var visible =
          $(this).data("visible") !== undefined
            ? $(this).data("visible")
            : true;
        var visibleincolvis =
          $(this).data("visibleincolvis") !== undefined
            ? $(this).data("visibleincolvis")
            : true;
        var width = $(this).data("width");
        var orderable =
          $(this).data("orderable") !== undefined
            ? $(this).data("orderable")
            : true;
        var className = $(this).data("class-name") || "";
        var column_search =
          $(this).data("column-search") !== undefined
            ? $(this).data("column-search")
            : true;

        // Check for the data-default-order attribute and store it
        var defaultOrderDir = $(this).data("default-order");
        if (defaultOrderDir) {
          defaultOrder.push([index, defaultOrderDir]); // Store index and order direction (asc/desc)
        }

        // Push column definitions to the columns array for DataTables
        columns.push({
          data: index,
          visible: visible,
          width: width,
          orderable: orderable,
          className: className,
          visibleincolvis: visibleincolvis,
          column_search: column_search,
        });

        // Add column-specific search inputs based on data-column-search

        if (column_search) {
          // Create a native search input with type="search" for the cancel button
          $(".search-row").append(
            `<th><input type="search" class="column-search form-control form-control-sm" data-index="${index}" placeholder="Search..." style="width:100%"></th>`
          );
        } else {
          $(".search-row").append("<th></th>"); // Leave empty if no search input is added
        }
      });

      // Button list for table actions (export, print, etc.)
      var button_list = [
        {
          extend: "colvis",
          text: colvis_text,
          titleAttr: "Col visibility",
          className: "btn-outline-primary btn-sm",
          columns: function (index) {
            return columns[index].visibleincolvis;
          },
        },
      ];

      var button_data = $(this).attr("data-buton");

      // Add export buttons if no custom buttons are defined
      if (typeof button_data == "undefined") {
        button_list.push([
          {
            extend: "pdfHtml5",
            className: "btn-outline-primary btn-sm",
            init: function (api, node) {
              $(node).removeClass("btn-secondary");
            },
          },
          {
            extend: "excelHtml5",
            className: "btn-outline-primary btn-sm",
            init: function (api, node) {
              $(node).removeClass("btn-secondary");
            },
          },
          {
            extend: "csvHtml5",
            className: "btn-outline-primary btn-sm",
            init: function (api, node) {
              $(node).removeClass("btn-secondary");
            },
          },
          {
            extend: "copyHtml5",
            className: "btn-outline-primary btn-sm",
            init: function (api, node) {
              $(node).removeClass("btn-secondary");
            },
          },
          {
            extend: "print",
            className: "btn-outline-primary btn-sm",
            init: function (api, node) {
              $(node).removeClass("btn-secondary");
            },
          },
        ]);
      }

      // Identify date and datetime columns
      var date_columns = [];
      var datetime_columns = [];

      $("th", current_table).each(function () {
        var dataType = $(this).data("type");

        if (dataType === null || dataType === undefined) {
          return;
        }

        if (dataType === "date") {
          date_columns.push($(this).parent().children().index($(this)));
        } else if (dataType === "datetime") {
          datetime_columns.push($(this).parent().children().index($(this)));
        }
      });

      var redesign_row = function (row, data, dataIndex) {
        if (date_columns.length !== 0) {
          $.each(date_columns, function (i, v) {
            var $dateCell = $(row).find("td:eq(" + v + ")");
            if ($dateCell.text() != "") {
              var dateOrder = new Date($dateCell.text() * 1000);
              $dateCell
                .attr("data-order", dateOrder)
                .text(dateOrder.format("d-m-Y"));
            }
          });
        }
        if (datetime_columns.length !== 0) {
          $.each(datetime_columns, function (i, v) {
            var $dateCell = $(row).find("td:eq(" + v + ")");
            if ($dateCell.text() != "") {
              var dateOrder = new Date($dateCell.text() * 1000);
              $dateCell
                .attr("data-order", dateOrder)
                .text(dateOrder.format("d-m-Y H:i:s"));
            }
          });
        }
      };

      // Initialize the data table
      var ctable = current_table.DataTable({
        language: {
          url: "/assets/common/js/01.datatable_i18n/" + lang_code + ".json",
          paginate: {
            previous: "<i class='fa-regular fa-chevron-left'></i>",
            next: "<i class='fa-regular fa-chevron-right'></i>",
            first: "<i class='fa-regular fa-chevrons-left'></i>",
            last: "<i class='fa-regular fa-chevrons-right'></i>",
          },
        },
        responsive: {
          details: {
            display: $.fn.dataTable.Responsive.display.modal({
              header: function (row) {
                var data = row.data();
                return data[0];
              },
            }),
            renderer: $.fn.dataTable.Responsive.renderer.tableAll({
              tableClass: "table table-responsive",
            }),
          },
        },
        stateSave: true,
        stateSaveCallback: function (settings, data) {
          localStorage.setItem(
            "DataTables_" + settings.sInstance,
            JSON.stringify(data)
          );
        },
        stateLoadCallback: function (settings) {
          return JSON.parse(
            localStorage.getItem("DataTables_" + settings.sInstance)
          );
        },
        columns: columns,
        lengthChange: true,
        pageLength: 25,
        fixedHeader: true,
        orderCellsTop: true,
        serverSide: true,
        order: defaultOrder.length ? defaultOrder : [[0, "asc"]], // Default to the custom order or fall back to index 0
        ajax: {
          url: source,
          type: "POST",
          data: {
            table: db_table,
            addon: addon,
            def_search: def_search,
            table_from: table_from,
            table_to: table_to,
          },
          dataSrc: function (data) {
            if (typeof data.pagetotal !== "undefined") {
              $("#toplam").html(
                number_format(data.pagetotal, 2, ",", ".") +
                  " TL (" +
                  number_format(data.total, 2, ",", ".") +
                  " TL)"
              );
            }
            return data.data;
          },
        },
        createdRow: redesign_row,
        dom:
          "<'row mb-3'<'col-sm-12 col-md-4 d-flex align-items-center justify-content-start'f><'col-sm-12 col-md-8 d-flex align-items-center justify-content-end' B>>" +
          "<'row'<'col-sm-12'tr>>" +
          "<'row'<'col-sm-12 col-md-6 d-flex justify-content-between align-items-center'li><'col-sm-12 col-md-6 d-flex justify-content-end align-items-center'p>>",
        lengthMenu: [
          [25, 50, 100, -1],
          [25, 50, 100, "Hepsi"],
        ],
        drawCallback: function () {
          $(".paginate_button.previous").html(
            '<i class="fa-regular fa-chevron-left"></i>'
          );
          $(".paginate_button.next").html(
            '<i class="fa-regular fa-chevron-right"></i>'
          );
        },
        buttons: button_list,
        initComplete: function (settings, json) {
          var state = this.api().state.loaded(); // Get stored state if available
          var placeholderText = settings.oLanguage.sSearch || "Search...";

          // Loop through each column and apply search input only where column_search is true
          this.api()
            .columns()
            .every(function (index) {
              var column = this;
              var colData = columns[index]; // Access stored column definition with column_search

              // Check if column_search is enabled for this column
              if (colData.column_search) {
                // Check if an input already exists in the .search-row for this column
                var input = $(".search-row").find(
                  `input[data-index="${index}"]`
                );
                // Trigger search when input length is >= 2 or empty
                if (input.val() === 0 || input.val() >= 2) {
                  column.search(input.value).draw();
                }

                // Restore saved search state for the column, if available
                if (state && state.columns[index].search.search) {
                  input.val(state.columns[index].search.search); // Load saved search value
                }

                // Apply additional styling
                $(column.header()).addClass("px-1");
              }
            });
        },
      });

      // General search input (top header)
      $(".dataTables_filter input")
        .off()
        .on("input", function () {
          var searchTerm = $(this).val();
          if (searchTerm.length >= 2 || searchTerm.length === 0) {
            ctable.search(searchTerm).draw();
          }
        });

      // Column-specific search with 2-character trigger
      $(".column-search").on("input", function () {
        var columnIndex = $(this).data("index");
        var searchValue = $(this).val();
        if (searchValue.length >= 2 || searchValue.length === 0) {
          ctable.columns(columnIndex).search(searchValue).draw();
        }
      });

      ctable.on("draw.dt", function () {
        setTimeout(function () {
          initTooltipIcons();
          $(".pagination .page-link").each(function () {
            var pageLinkHtml = $(this).html();
            var pageNumber = parseInt(pageLinkHtml.replace(/\./g, ""), 10);
            if (pageNumber > 1000) {
              $(this).css("font-size", "12px");
            }
          });
        }, 400);
      });
      hideLoader();
    }
  });
}

function tableInit_new() {
  $(".dt-general").each(function () {
    var current_table = $(this);
    // Check if DataTable is already initialized
    if (!$.fn.DataTable.isDataTable(current_table)) {
      showLoader();
      var source = $(current_table).data("source");
      var db_table = $(current_table).data("table");
      var addon = $(current_table).data("addon");
      var def_search = $(current_table).data("table-def-search");
      var table_from = $("#table_from").val();
      var table_to = $("#table_to").val();
      var colvis_text = $(this).data("colvis");
      var lang_code = $("html").attr("lang");

      var columns = [];
      var defaultOrder = []; // To store the default order

      // Add a new row for column search inputs below the header
      $(current_table).find("thead").append('<tr class="search-row"></tr>');

      // Loop through each th in thead
      $("th", current_table).each(function (index) {
        var visible =
          $(this).data("visible") !== undefined
            ? $(this).data("visible")
            : true;
        var visibleincolvis =
          $(this).data("visibleincolvis") !== undefined
            ? $(this).data("visibleincolvis")
            : true;
        var width = $(this).data("width");
        var orderable =
          $(this).data("orderable") !== undefined
            ? $(this).data("orderable")
            : true;
        var className = $(this).data("class-name") || "";
        var column_search =
          $(this).data("column-search") !== undefined
            ? $(this).data("column-search")
            : true;

        // Check for the data-default-order attribute and store it
        var defaultOrderDir = $(this).data("default-order");
        if (defaultOrderDir) {
          defaultOrder.push([index, defaultOrderDir]); // Store index and order direction (asc/desc)
        }

        // Push column definitions to the columns array for DataTables
        columns.push({
          data: index,
          visible: visible,
          width: width,
          orderable: orderable,
          className: className,
          visibleincolvis: visibleincolvis,
          column_search: column_search,
        });

        // Add column-specific search inputs based on data-column-search
        if (column_search) {
          $(".search-row").append(
            `<th><input type="search" class="column-search form-control form-control-sm" data-index="${index}" placeholder="Search..." style="width:100%"></th>`
          );
        } else {
          $(".search-row").append("<th></th>"); // Leave empty if no search input is added
        }
      });

      // Button list for table actions (export, print, etc.)
      var button_list = [
        {
          extend: "colvis",
          text: colvis_text,
          titleAttr: "Col visibility",
          className: "btn-outline-primary btn-sm",
          columns: function (index) {
            return columns[index].visibleincolvis;
          },
        },
      ];

      var button_data = $(this).attr("data-buton");

      // Add export buttons if no custom buttons are defined
      if (typeof button_data == "undefined") {
        button_list.push([
          {
            extend: "pdfHtml5",
            className: "btn-outline-primary btn-sm",
            init: function (api, node) {
              $(node).removeClass("btn-secondary");
            },
          },
          {
            extend: "excelHtml5",
            className: "btn-outline-primary btn-sm",
            init: function (api, node) {
              $(node).removeClass("btn-secondary");
            },
          },
          {
            extend: "csvHtml5",
            className: "btn-outline-primary btn-sm",
            init: function (api, node) {
              $(node).removeClass("btn-secondary");
            },
          },
          {
            extend: "copyHtml5",
            className: "btn-outline-primary btn-sm",
            init: function (api, node) {
              $(node).removeClass("btn-secondary");
            },
          },
          {
            extend: "print",
            className: "btn-outline-primary btn-sm",
            init: function (api, node) {
              $(node).removeClass("btn-secondary");
            },
          },
        ]);
      }

      // Check if source is provided for server-side processing
      var ajaxConfig = source
        ? {
            url: source,
            type: "POST",
            data: {
              table: db_table,
              addon: addon,
              def_search: def_search,
              table_from: table_from,
              table_to: table_to,
            },
            dataSrc: function (data) {
              if (typeof data.pagetotal !== "undefined") {
                $("#toplam").html(
                  number_format(data.pagetotal, 2, ",", ".") +
                    " TL (" +
                    number_format(data.total, 2, ",", ".") +
                    " TL)"
                );
              }
              return data.data;
            },
          }
        : null; // If source is empty, skip the ajax configuration

      // Initialize the data table
      var ctable = current_table.DataTable({
        language: {
          url: "/assets/common/js/01.datatable_i18n/" + lang_code + ".json",
          paginate: {
            previous: "<i class='fa-regular fa-chevron-left'></i>",
            next: "<i class='fa-regular fa-chevron-right'></i>",
            first: "<i class='fa-regular fa-chevrons-left'></i>",
            last: "<i class='fa-regular fa-chevrons-right'></i>",
          },
        },
        responsive: {
          details: {
            display: $.fn.dataTable.Responsive.display.modal({
              header: function (row) {
                var data = row.data();
                return data[0];
              },
            }),
            renderer: $.fn.dataTable.Responsive.renderer.tableAll({
              tableClass: "table table-responsive",
            }),
          },
        },
        stateSave: true,
        stateSaveCallback: function (settings, data) {
          localStorage.setItem(
            "DataTables_" + settings.sInstance,
            JSON.stringify(data)
          );
        },
        stateLoadCallback: function (settings) {
          return JSON.parse(
            localStorage.getItem("DataTables_" + settings.sInstance)
          );
        },
        columns: columns,
        lengthChange: true,
        pageLength: 25,
        fixedHeader: true,
        orderCellsTop: true,
        serverSide: !!source, // Only enable serverSide if source is defined
        order: defaultOrder.length ? defaultOrder : [[0, "asc"]],
        ajax: ajaxConfig, // Use ajaxConfig, which is null if no source is provided
        createdRow: redesign_row,
        dom:
          "<'row mb-3'<'col-sm-12 col-md-4 d-flex align-items-center justify-content-start'f><'col-sm-12 col-md-8 d-flex align-items-center justify-content-end' B>>" +
          "<'row'<'col-sm-12'tr>>" +
          "<'row'<'col-sm-12 col-md-6 d-flex justify-content-between align-items-center'li><'col-sm-12 col-md-6 d-flex justify-content-end align-items-center'p>>",
        lengthMenu: [
          [25, 50, 100, -1],
          [25, 50, 100, "Hepsi"],
        ],
        drawCallback: function () {
          $(".paginate_button.previous").html(
            '<i class="fa-regular fa-chevron-left"></i>'
          );
          $(".paginate_button.next").html(
            '<i class="fa-regular fa-chevron-right"></i>'
          );
        },
        buttons: button_list,
        initComplete: function (settings, json) {
          var state = this.api().state.loaded();
          var placeholderText = settings.oLanguage.sSearch || "Search...";

          this.api()
            .columns()
            .every(function (index) {
              var column = this;
              var colData = columns[index];

              if (colData.column_search) {
                var input = $(".search-row").find(
                  `input[data-index="${index}"]`
                );
                if (input.val() === 0 || input.val() >= 2) {
                  column.search(input.value).draw();
                }
                if (state && state.columns[index].search.search) {
                  input.val(state.columns[index].search.search);
                }
                $(column.header()).addClass("px-1");
              }
            });
        },
      });

      $(".dataTables_filter input")
        .off()
        .on("input", function () {
          var searchTerm = $(this).val();
          if (searchTerm.length >= 2 || searchTerm.length === 0) {
            ctable.search(searchTerm).draw();
          }
        });

      $(".column-search").on("input", function () {
        var columnIndex = $(this).data("index");
        var searchValue = $(this).val();
        if (searchValue.length >= 2 || searchValue.length === 0) {
          ctable.columns(columnIndex).search(searchValue).draw();
        }
      });

      ctable.on("draw.dt", function () {
        setTimeout(function () {
          $(".pagination .page-link").each(function () {
            var pageLinkHtml = $(this).html();
            var pageNumber = parseInt(pageLinkHtml.replace(/\./g, ""), 10);
            if (pageNumber > 1000) {
              $(this).css("font-size", "12px");
            }
          });
        }, 400);
      });
      hideLoader();
    }
  });
}

// =========================================
// FORM SUBMISSION & SIGN OUT METHODS
// =========================================

// Function to log out the user by submitting the signout request
function signOut() {
  var currentLang = $("html").attr("lang");
  var defaultLang = $("html").data("default-lang");

  var target =
    (currentLang != defaultLang ? "/" + currentLang : "") +
    "/authController/signoutUser";
  var form_content = "";
  submitForm(target, form_content);
}

// AJAX form submission handler
function form_submit() {
  $(document).on("submit", ".ajax-form", function (e) {
    e.preventDefault();
    var form = $(this);
    var target = "/" + $("html").attr("lang") + form.data("target");

    var form_content = form.serializeArray();

    // Call function to submit form data
    submitForm(target, form_content);
  });
}

// Function to submit a form using AJAX
function submitForm(target, form_content) {
  $.ajax({
    async: false,
    type: "POST",
    url: target,
    data: form_content,
    beforeSend: function () {
      showLoader();
    },
    success: function (response) {
      hideLoader();
      try {
        var data = JSON.parse(response);
      } catch (error) {
        debug && console.error("Invalid JSON response:", error);
        return;
      }
      runResponse(data);
    },
    error: function (xhr) {
      hideLoader();
      alert(
        "Error occurred. Please try again: " + xhr.statusText + xhr.responseText
      );
    },
    complete: function () {
      hideLoader();
    },
  });
}

function runResponse(data) {
  if (data.hasOwnProperty("destination")) {
    if (!debug) window.location.href = data.destination;
  } else if (data.hasOwnProperty("js_function")) {
    try {
      if (debug) {
        console.log(data.js_function);
      }
      eval(data.js_function); // Execute JS function from the response
    } catch (error) {
      debug && console.error("Error executing JS function:", error);
    }
  } else {
    if (!debug) location.reload();
  }
}

// =========================================
// UTILITY METHODS
// =========================================

// Function to check file type against a list of allowed types
function checkFileType(file, list) {
  var retVal = false;
  $.each(list, function (i, v) {
    if (file.type == v) {
      retVal = true;
    }
  });
  return retVal;
}

// Function to check if a string is a valid JSON format
function isJson(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return false;
  }
}

// Function to retrieve the operating system and browser details
function getOS() {
  const unknown = "-";
  let screenSize = "";

  // Get screen resolution
  if (screen.width) {
    screenSize = `${screen.width} x ${screen.height}`;
  }

  // Use navigator.userAgent for browser and OS detection
  const nAgt = navigator.userAgent;
  let browser = "Unknown Browser";
  let version = "Unknown Version";
  let majorVersion;
  let nameOffset, verOffset, ix;

  // Browser detection
  if ((verOffset = nAgt.indexOf("Opera")) != -1) {
    browser = "Opera";
    version = nAgt.substring(verOffset + 6);
    if ((verOffset = nAgt.indexOf("Version")) != -1) {
      version = nAgt.substring(verOffset + 8);
    }
  } else if ((verOffset = nAgt.indexOf("OPR")) != -1) {
    browser = "Opera";
    version = nAgt.substring(verOffset + 4);
  } else if ((verOffset = nAgt.indexOf("Edge")) != -1) {
    browser = "Microsoft Legacy Edge";
    version = nAgt.substring(verOffset + 5);
  } else if ((verOffset = nAgt.indexOf("Edg")) != -1) {
    browser = "Microsoft Edge";
    version = nAgt.substring(verOffset + 4);
  } else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
    browser = "Chrome";
    version = nAgt.substring(verOffset + 7);
  } else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
    browser = "Safari";
    version = nAgt.substring(verOffset + 7);
    if ((verOffset = nAgt.indexOf("Version")) != -1) {
      version = nAgt.substring(verOffset + 8);
    }
  } else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
    browser = "Firefox";
    version = nAgt.substring(verOffset + 8);
  } else if (nAgt.indexOf("Trident/") != -1) {
    browser = "Microsoft Internet Explorer";
    version = nAgt.substring(nAgt.indexOf("rv:") + 3);
  } else if (
    (nameOffset = nAgt.lastIndexOf(" ") + 1) <
    (verOffset = nAgt.lastIndexOf("/"))
  ) {
    browser = nAgt.substring(nameOffset, verOffset);
    version = nAgt.substring(verOffset + 1);
    if (browser.toLowerCase() === browser.toUpperCase()) {
      browser = navigator.appName;
    }
  }

  // Clean up version string
  if ((ix = version.indexOf(";")) != -1) version = version.substring(0, ix);
  if ((ix = version.indexOf(" ")) != -1) version = version.substring(0, ix);
  if ((ix = version.indexOf(")")) != -1) version = version.substring(0, ix);

  majorVersion = parseInt(version, 10);
  if (isNaN(majorVersion)) {
    majorVersion = parseInt(nAgt, 10);
  }

  // Mobile device detection
  const mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nAgt);

  // Check for cookie support
  let cookieEnabled = navigator.cookieEnabled;
  if (typeof navigator.cookieEnabled === "undefined" && !cookieEnabled) {
    document.cookie = "testcookie";
    cookieEnabled = document.cookie.indexOf("testcookie") != -1 ? true : false;
  }

  // OS detection
  let os = unknown;
  let osVersion = unknown;
  const clientStrings = [
    { s: "Windows 11", r: /(Windows 11|Windows NT 10.0)/ },
    { s: "Windows 10", r: /(Windows 10.0|Windows NT 10.0)/ },
    { s: "Windows 8.1", r: /(Windows 8.1|Windows NT 6.3)/ },
    { s: "Windows 8", r: /(Windows 8|Windows NT 6.2)/ },
    { s: "Windows 7", r: /(Windows 7|Windows NT 6.1)/ },
    { s: "Windows Vista", r: /Windows NT 6.0/ },
    { s: "Windows Server 2003", r: /Windows NT 5.2/ },
    { s: "Windows XP", r: /(Windows NT 5.1|Windows XP)/ },
    { s: "Windows 2000", r: /(Windows NT 5.0|Windows 2000)/ },
    { s: "Windows ME", r: /(Win 9x 4.90|Windows ME)/ },
    { s: "Windows 98", r: /(Windows 98|Win98)/ },
    { s: "Windows 95", r: /(Windows 95|Win95|Windows_95)/ },
    { s: "Windows NT 4.0", r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
    { s: "Windows CE", r: /Windows CE/ },
    { s: "Windows 3.11", r: /Win16/ },
    { s: "Android", r: /Android/ },
    { s: "Chrome OS", r: /CrOS/ },
    { s: "Linux", r: /(Linux|X11(?!.*CrOS))/ },
    { s: "iOS", r: /(iPhone|iPad|iPod)/ },
    { s: "Mac OS X", r: /Mac OS X/ },
    { s: "Mac OS", r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
    { s: "FreeBSD", r: /FreeBSD/ },
    { s: "OpenBSD", r: /OpenBSD/ },
    { s: "Sun OS", r: /SunOS/ },
    { s: "QNX", r: /QNX/ },
    { s: "UNIX", r: /UNIX/ },
    { s: "BeOS", r: /BeOS/ },
    { s: "OS/2", r: /OS\/2/ },
    { s: "Plan 9", r: /Plan 9/ },
    { s: "DragonFly BSD", r: /DragonFly/ },
    { s: "Haiku", r: /Haiku/ },
    { s: "IRIX", r: /IRIX/ },
    { s: "RISC OS", r: /RISC OS/ },
    {
      s: "Search Bot",
      r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/,
    },
  ];

  for (let id in clientStrings) {
    const cs = clientStrings[id];
    if (cs.r.test(nAgt)) {
      os = cs.s;
      break;
    }
  }

  // Extract OS version if applicable
  if (/Windows/.test(os)) {
    osVersion = /Windows (.*)/.exec(os)[1];
    os = "Windows";
  } else if (os === "Mac OS X" || os === "Android") {
    osVersion = /(?:Mac OS X|Android) ([\.\_\d]+)/.exec(nAgt)[1];
  } else if (os === "iOS") {
    osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nAgt);
    osVersion = osVersion ? osVersion.slice(1).join(".") : unknown;
  }

  return {
    screen: screenSize,
    browser: browser,
    browserVersion: version,
    browserMajorVersion: majorVersion,
    mobile: mobile,
    os: os,
    osVersion: osVersion,
    cookies: cookieEnabled,
  };
}

// Function to show/hide password input text
function showPassword() {
  var x = document.getElementById("password");
  if (x.type === "password") {
    x.type = "text";
    $(".show-password-icon").removeClass("fa-light").addClass("fa-solid");
  } else {
    x.type = "password";
    $(".show-password-icon").removeClass("fa-solid").addClass("fa-light");
  }
}

// Function to copy text to clipboard
function copyToClipboard(value) {
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val(value).select();
  document.execCommand("copy");
  $temp.remove();
}

// Function to format numbers
function number_format(number, decimals, dec_point, thousands_sep) {
  number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
  var n = !isFinite(+number) ? 0 : +number;
  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  var sep = typeof thousands_sep === "undefined" ? "," : thousands_sep;
  var dec = typeof dec_point === "undefined" ? "." : dec_point;
  var s = "";
  var toFixedFix = function (n, prec) {
    var k = Math.pow(10, prec);
    return "" + Math.round(n * k) / k;
  };
  s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }
  return s.join(dec);
}

function handleOTPInputs() {
  const $inputs = $(".otp-input");

  $inputs.on("input", function () {
    const index = $inputs.index(this);
    if ($(this).val().length === 1 && index < $inputs.length - 1) {
      $inputs.eq(index + 1).focus(); // Move to the next input by index
    }
  });

  $inputs.on("paste", function (e) {
    const pasteData = e.originalEvent.clipboardData.getData("text").slice(0, 6);
    $inputs.each(function (i) {
      $(this).val(pasteData[i] || ""); // Paste each digit into the respective input
    });
    $inputs.last().focus(); // Focus on the last input after pasting
  });

  $inputs.on("keydown", function (e) {
    const index = $inputs.index(this);
    if (e.key === "Backspace" && !$(this).val() && index > 0) {
      $inputs.eq(index - 1).focus(); // Move to the previous input by index
    }
  });
}

function showOTP(time, unit) {
  $(".otp-section").removeClass("d-none");

  $(".sign-in-button").html($(".sign-in-button").data("submit-text"));

  let counter;
  let interval;

  function counterF() {
    counter--; // Decrease counter in the closure
    $("#counter").html(counter);
    if (counter == 0) {
      clearInterval(interval);
      $(".otp-section").addClass("d-none");
      $(".sign-in-button").html($(".sign-in-button").data("request-otp-text"));
    }
  }

  clearInterval(interval);
  counter = time; // Set counter from response
  $("#counter").html(counter);
  $("#counter_unit").html(unit);
  interval = setInterval(counterF, 1000); // Start interval, closure will keep variables
}

function clearOTPFields() {
  const otpInputs = document.querySelectorAll(".otp-input");
  otpInputs.forEach((input) => (input.value = "")); // Clear each OTP input field
  $(".otp-error").removeClass("d-none");
}

function showCustomSwal({
  title = "",
  text = "",
  icon = "",
  confirmButtonText = "OK",
  cancelButtonText = "Cancel",
  showCancelButton = false,
  showCloseButton = false,
  timer = null,
  input = null,
  inputPlaceholder = "",
  inputValue = "",
  allowOutsideClick = true,
  customClass = {},
  callback = null, // Callback function for both timer or OK button click
}) {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton:
        customClass.confirmButton || "btn bg-gradient-success btn-lg",
      cancelButton: customClass.cancelButton || "btn bg-gradient-danger btn-lg",
    },
    buttonsStyling: false,
  });

  const swalConfig = {
    title: title,
    text: text,
    icon: icon, // 'warning', 'success', 'error', 'info', or 'question'
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    showCancelButton: showCancelButton,
    showCloseButton: showCloseButton,
    timer: timer,
    input: input, // 'text', 'email', 'password', etc.
    inputPlaceholder: inputPlaceholder,
    inputValue: inputValue,
    allowOutsideClick: allowOutsideClick,
  };

  swalWithBootstrapButtons.fire(swalConfig).then((result) => {
    if (result.isConfirmed || result.dismiss === Swal.DismissReason.timer) {
      if (callback && typeof callback === "function") {
        callback();
      }
    }
  });
}

function sidebarColorUser(a) {
  var parent = a.parentElement.children;
  var color = a.getAttribute("data-color");

  var user_type = $(".change-lang").data("user-type");
  var user_id = $(".change-lang").data("user-id");

  for (var i = 0; i < parent.length; i++) {
    parent[i].classList.remove("active");
  }

  if (!a.classList.contains("active")) {
    a.classList.add("active");
  } else {
    a.classList.remove("active");
  }

  var sidebar = document.querySelector(".sidenav");
  sidebar.setAttribute("data-color", color);

  if (document.querySelector("#sidenavCard")) {
    var sidenavCard = document.querySelector("#sidenavCard");
    let sidenavCardClasses = [
      "card",
      "card-background",
      "shadow-none",
      "card-background-mask-" + color,
    ];
    sidenavCard.className = "";
    sidenavCard.classList.add(...sidenavCardClasses);

    var sidenavCardIcon = document.querySelector("#sidenavCardIcon");
    let sidenavCardIconClasses = [
      "ni",
      "ni-diamond",
      "text-gradient",
      "text-lg",
      "top-0",
      "text-" + color,
    ];
    sidenavCardIcon.className = "";
    sidenavCardIcon.classList.add(...sidenavCardIconClasses);
  }

  $.ajax({
    async: false,
    type: "POST",
    url: "/userManagementController/veriUserUpdate",
    data: { user_type: user_type, id: user_id, sidebarColor: color },
    beforeSend: function () {
      showLoader();
    },
    success: function (response) {
      hideLoader();
      try {
        var data = JSON.parse(response);
      } catch (error) {
        debug && console.error("Invalid JSON response:", error);
        return;
      }
      runResponse(data);
    },
  });
}

function darkModeUser(el) {
  const body = document.getElementsByTagName("body")[0];
  const hr = document.querySelectorAll("div:not(.sidenav) > hr");
  const sidebar = document.querySelector(".sidenav");
  const sidebarWhite = document.querySelectorAll(".sidenav.bg-white");
  const hr_card = document.querySelectorAll("div:not(.bg-gradient-dark) hr");
  const text_btn = document.querySelectorAll("button:not(.btn) > .text-dark");
  const text_span = document.querySelectorAll(
    "span.text-dark, .breadcrumb .text-dark"
  );
  const text_span_white = document.querySelectorAll(
    "span.text-white, .breadcrumb .text-white"
  );
  const text_strong = document.querySelectorAll("strong.text-dark");
  const text_strong_white = document.querySelectorAll("strong.text-white");
  const text_nav_link = document.querySelectorAll("a.nav-link.text-dark");
  const secondary = document.querySelectorAll(".text-secondary");
  const secondary_light = document.querySelectorAll(".text-white");
  const bg_gray_100 = document.querySelectorAll(".bg-gray-100");
  const bg_gray_600 = document.querySelectorAll(".bg-gray-600");
  const btn_text_dark = document.querySelectorAll(
    ".btn.btn-link.text-dark, .btn .ni.text-dark"
  );
  const btn_text_white = document.querySelectorAll(
    ".btn.btn-link.text-white, .btn .ni.text-white"
  );
  const card_border = document.querySelectorAll(".card.border");
  const card_border_dark = document.querySelectorAll(
    ".card.border.border-dark"
  );
  const svg = document.querySelectorAll(".navbar g");
  const navbarBrand = document.querySelector(".navbar-brand-img");
  const navbarBrandImg = navbarBrand.src;
  const navLinks = document.querySelectorAll(
    ".navbar-main .nav-link, .navbar-main .breadcrumb-item, .navbar-main .breadcrumb-item a"
  );
  const cardNavLinksIcons = document.querySelectorAll(".card .nav .nav-link i");
  const cardNavSpan = document.querySelectorAll(".card .nav .nav-link span");
  const fixedPlugin_blur = document.querySelectorAll(".fixed-plugin > .card");
  const mainContent_blur = document.querySelectorAll(
    ".main-content .container-fluid .card"
  );

  if (!el.getAttribute("checked")) {
    var darkmode = "checked";
    body.classList.add("dark-version");
    if (navbarBrandImg.includes("veri-enstitusu-dashboard-logo.svg")) {
      var navbarBrandImgNew = navbarBrandImg.replace(
        "dashboard-logo",
        "dashboard-logo-dark"
      );
      navbarBrand.src = navbarBrandImgNew;
    }

    for (var i = 0; i < mainContent_blur.length; i++) {
      if (mainContent_blur[i].classList.contains("blur")) {
        mainContent_blur[i].classList.remove("blur", "shadow-blur");
      }
    }
    for (var i = 0; i < navLinks.length; i++) {
      if (navLinks[i].classList.contains("text-white")) {
        navLinks[i].classList.remove("text-white");
      }
    }
    for (var i = 0; i < fixedPlugin_blur.length; i++) {
      if (fixedPlugin_blur[i].classList.contains("blur")) {
        fixedPlugin_blur[i].classList.remove("blur");
      }
    }
    for (var i = 0; i < cardNavLinksIcons.length; i++) {
      if (cardNavLinksIcons[i].classList.contains("text-dark")) {
        cardNavLinksIcons[i].classList.remove("text-dark");
        cardNavLinksIcons[i].classList.add("text-white");
      }
    }
    for (var i = 0; i < cardNavSpan.length; i++) {
      if (cardNavSpan[i].classList.contains("text-sm")) {
        cardNavSpan[i].classList.add("text-white");
      }
    }
    for (var i = 0; i < hr.length; i++) {
      if (hr[i].classList.contains("dark")) {
        hr[i].classList.remove("dark");
        hr[i].classList.add("light");
      }
    }
    for (var i = 0; i < hr_card.length; i++) {
      if (hr_card[i].classList.contains("dark")) {
        hr_card[i].classList.remove("dark");
        hr_card[i].classList.add("light");
      }
    }
    for (var i = 0; i < text_btn.length; i++) {
      if (text_btn[i].classList.contains("text-dark")) {
        text_btn[i].classList.remove("text-dark");
        text_btn[i].classList.add("text-white");
      }
    }
    for (var i = 0; i < text_span.length; i++) {
      if (text_span[i].classList.contains("text-dark")) {
        text_span[i].classList.remove("text-dark");
        text_span[i].classList.add("text-white");
      }
    }
    for (var i = 0; i < text_strong.length; i++) {
      if (text_strong[i].classList.contains("text-dark")) {
        text_strong[i].classList.remove("text-dark");
        text_strong[i].classList.add("text-white");
      }
    }
    for (var i = 0; i < text_nav_link.length; i++) {
      if (text_nav_link[i].classList.contains("text-dark")) {
        text_nav_link[i].classList.remove("text-dark");
        text_nav_link[i].classList.add("text-white");
      }
    }
    for (var i = 0; i < secondary.length; i++) {
      if (secondary[i].classList.contains("text-secondary")) {
        secondary[i].classList.remove("text-secondary");
        secondary[i].classList.add("text-white");
        secondary[i].classList.add("opacity-8");
      }
    }
    for (var i = 0; i < bg_gray_100.length; i++) {
      if (bg_gray_100[i].classList.contains("bg-gray-100")) {
        bg_gray_100[i].classList.remove("bg-gray-100");
        bg_gray_100[i].classList.add("bg-gray-600");
      }
    }
    for (var i = 0; i < btn_text_dark.length; i++) {
      btn_text_dark[i].classList.remove("text-dark");
      btn_text_dark[i].classList.add("text-white");
    }
    for (var i = 0; i < sidebarWhite.length; i++) {
      sidebarWhite[i].classList.remove("bg-white");
    }
    for (var i = 0; i < svg.length; i++) {
      if (svg[i].hasAttribute("fill")) {
        svg[i].setAttribute("fill", "#fff");
      }
    }
    for (var i = 0; i < card_border.length; i++) {
      card_border[i].classList.add("border-dark");
    }
    el.setAttribute("checked", "true");
  } else {
    var darkmode = "unchecked";
    body.classList.remove("dark-version");
    sidebar.classList.add("bg-white");
    if (navbarBrandImg.includes("veri-enstitusu-dashboard-logo-dark.svg")) {
      var navbarBrandImgNew = navbarBrandImg.replace(
        "dashboard-logo-dark",
        "dashboard-logo"
      );
      navbarBrand.src = navbarBrandImgNew;
    }
    for (var i = 0; i < navLinks.length; i++) {
      if (navLinks[i].classList.contains("text-dark")) {
        navLinks[i].classList.add("text-white");
        navLinks[i].classList.remove("text-dark");
      }
    }
    for (var i = 0; i < cardNavLinksIcons.length; i++) {
      if (cardNavLinksIcons[i].classList.contains("text-white")) {
        cardNavLinksIcons[i].classList.remove("text-white");
        cardNavLinksIcons[i].classList.add("text-dark");
      }
    }
    for (var i = 0; i < cardNavSpan.length; i++) {
      if (cardNavSpan[i].classList.contains("text-white")) {
        cardNavSpan[i].classList.remove("text-white");
      }
    }
    for (var i = 0; i < mainContent_blur.length; i++) {
      mainContent_blur[i].classList.add("blur", "shadow-blur");
    }
    for (var i = 0; i < fixedPlugin_blur.length; i++) {
      fixedPlugin_blur[i].classList.add("blur");
    }
    for (var i = 0; i < hr.length; i++) {
      if (hr[i].classList.contains("light")) {
        hr[i].classList.add("dark");
        hr[i].classList.remove("light");
      }
    }
    for (var i = 0; i < hr_card.length; i++) {
      if (hr_card[i].classList.contains("light")) {
        hr_card[i].classList.add("dark");
        hr_card[i].classList.remove("light");
      }
    }
    for (var i = 0; i < text_btn.length; i++) {
      if (text_btn[i].classList.contains("text-white")) {
        text_btn[i].classList.remove("text-white");
        text_btn[i].classList.add("text-dark");
      }
    }
    for (var i = 0; i < text_span_white.length; i++) {
      if (
        text_span_white[i].classList.contains("text-white") &&
        !text_span_white[i].closest(".sidenav") &&
        !text_span_white[i].closest(".card.bg-gradient-dark")
      ) {
        text_span_white[i].classList.remove("text-white");
        text_span_white[i].classList.add("text-dark");
      }
    }
    for (var i = 0; i < text_strong_white.length; i++) {
      if (text_strong_white[i].classList.contains("text-white")) {
        text_strong_white[i].classList.remove("text-white");
        text_strong_white[i].classList.add("text-dark");
      }
    }
    for (var i = 0; i < secondary_light.length; i++) {
      if (secondary_light[i].classList.contains("text-white")) {
        secondary_light[i].classList.remove("text-white");
        secondary_light[i].classList.remove("opacity-8");
        secondary_light[i].classList.add("text-secondary");
      }
    }
    for (var i = 0; i < bg_gray_600.length; i++) {
      if (bg_gray_600[i].classList.contains("bg-gray-600")) {
        bg_gray_600[i].classList.remove("bg-gray-600");
        bg_gray_600[i].classList.add("bg-gray-100");
      }
    }
    for (var i = 0; i < svg.length; i++) {
      if (svg[i].hasAttribute("fill")) {
        svg[i].setAttribute("fill", "#6c757d");
      }
    }
    for (var i = 0; i < btn_text_white.length; i++) {
      if (!btn_text_white[i].closest(".card.bg-gradient-dark")) {
        btn_text_white[i].classList.remove("text-white");
        btn_text_white[i].classList.add("text-dark");
      }
    }
    for (var i = 0; i < card_border_dark.length; i++) {
      card_border_dark[i].classList.remove("border-dark");
    }
    el.removeAttribute("checked");
  }

  var user_type = $(".change-lang").data("user-type");
  var user_id = $(".change-lang").data("user-id");

  $.ajax({
    async: false,
    type: "POST",
    url: "/userManagementController/veriUserUpdate",
    data: { user_type: user_type, id: user_id, darkMode: darkmode },
    beforeSend: function () {
      showLoader();
    },
    success: function (response) {
      hideLoader();
      try {
        var data = JSON.parse(response);
      } catch (error) {
        debug && console.error("Invalid JSON response:", error);
        return;
      }
      runResponse(data);
    },
  });
}

function navbarMinimizeUser(el) {
  var sidenavShow = document.getElementsByClassName("g-sidenav-show")[0];
  if (!el.getAttribute("checked")) {
    var navbarMinimizeUser = "checked";
    sidenavShow.classList.remove("g-sidenav-pinned");
    sidenavShow.classList.add("g-sidenav-hidden");
    el.setAttribute("checked", "true");
  } else {
    var navbarMinimizeUser = "unchecked";
    sidenavShow.classList.remove("g-sidenav-hidden");
    sidenavShow.classList.add("g-sidenav-pinned");
    el.removeAttribute("checked");
  }

  var user_type = $(".change-lang").data("user-type");
  var user_id = $(".change-lang").data("user-id");

  $.ajax({
    async: false,
    type: "POST",
    url: "/userManagementController/veriUserUpdate",
    data: {
      user_type: user_type,
      id: user_id,
      navbarMinimize: navbarMinimizeUser,
    },
    beforeSend: function () {
      showLoader();
    },
    success: function (response) {
      hideLoader();
      try {
        var data = JSON.parse(response);
      } catch (error) {
        debug && console.error("Invalid JSON response:", error);
        return;
      }
      runResponse(data);
    },
  });
}

function initFlatPicker() {
  const langCode = $("html").attr("lang") || "en";

  $(".datepicker").each(function () {
    const $this = $(this);

    // Ensure any existing Flatpickr instance is destroyed to avoid stale references
    if ($this[0]._flatpickr) {
      if (debug) {
        console.log(
          `Destroying existing Flatpickr instance for ID: ${$this.attr("id")}`
        );
      }
      $this[0]._flatpickr.destroy();
    }

    // Get the updated range IDs
    const rangeStartId = $this.data("range-start");
    const rangeEndId = $this.data("range-end");

    // Initialize Flatpickr with locale and other options
    const options = {
      locale: flatpickr.l10ns[langCode],
      dateFormat: "Y-m-d",
      firstDayOfWeek: 1,
    };

    // Configure onChange for start date fields
    if (rangeEndId) {
      options.onChange = function (selectedDates) {
        if (selectedDates.length > 0) {
          if (debug) {
            console.log(`Setting minDate on end picker with ID: ${rangeEndId}`);
          }
          const endPicker = document.getElementById(rangeEndId)?._flatpickr;
          if (endPicker) {
            endPicker.set("minDate", selectedDates[0]);
          }
        }
      };
    }

    // Configure onChange for end date fields
    if (rangeStartId) {
      options.onChange = function (selectedDates) {
        if (selectedDates.length > 0) {
          if (debug) {
            console.log(
              `Setting maxDate on start picker with ID: ${rangeStartId}`
            );
          }
          const startPicker = document.getElementById(rangeStartId)?._flatpickr;
          if (startPicker) {
            startPicker.set("maxDate", selectedDates[0]);
          }
        }
      };
    }

    // Delay initialization to ensure DOM is fully updated
    setTimeout(() => {
      if (debug) {
        console.log(`Initializing Flatpickr for ID: ${$this.attr("id")}`);
      }
      $this.flatpickr(options);
    }, 10); // Short delay to avoid race conditions
  });
}

function initSelect2() {
  const language = $("html").attr("lang") || "en";

  // Dynamically load the Select2 language file
  $.getScript(`/assets/common/js/05.select2_i18n/${language}.js`)
    .done(function () {
      $(".choicesInput").each(function () {
        const $selectElement = $(this);

        // Initialize Select2 with the loaded translations
        if (!$selectElement.data("select2Initialized")) {
          triggerSelect2($selectElement, Select2I18n);
          $selectElement.data("select2Initialized", true);
        }
      });
    })
    .fail(function () {
      console.error(`Failed to load the language file for ${language}.`);
    });
}

function triggerSelect2($selectElement) {
  const isMultiSelect = $selectElement.data("multi-select") === true;
  const apiEndpoint = $selectElement.data("endpoint");
  const isAjax = $selectElement.data("ajax") === true;
  const triggerSearchMin = $selectElement.data("search-min-input") ?? 3;
  const fetchOnInit = $selectElement.data("fetch-on-init") === true;
  const selectionCountId = $selectElement.data("selection-count");
  const showSearch = $selectElement.data("show-search") !== false;
  const dropdownParent =
    $selectElement.data("dropdown-parent") ?? $(document.body);

  // Initialize Select2
  $selectElement.select2({
    width: "100%", // Full width of the element
    placeholder: $selectElement.data("placeholder") || Select2I18n.placeholder, // Use language file translations
    allowClear: true, // Allows clearing the selection
    multiple: isMultiSelect, // Enables multi-select
    minimumResultsForSearch: showSearch ? 0 : Infinity,
    dropdownParent: dropdownParent,
    language: Select2I18n,
    ajax: isAjax
      ? {
          url: apiEndpoint,
          dataType: "json",
          delay: 250, // Delay to reduce server load
          data: function (params) {
            return {
              search: params.term, // The search term entered by the user
              page: params.page || 1, // Current page number
              pageSize: 20, // Number of items per page
            };
          },
          processResults: function (data, params) {
            // Update page number
            params.page = params.page || 1;

            return {
              results: data.results.map((item) => ({
                id: item.id,
                text: item.text,
              })),
              pagination: {
                more: data.results.length === 20, // If 20 items are returned, more pages exist
              },
            };
          },
        }
      : null,

    templateResult: function (item) {
      if (!item.id) {
        // Placeholder item or no ID
        return item.text || placeholder;
      }
      // Return the text for regular items
      return item.text;
    },

    templateSelection: function (item) {
      return item.text; // Display plain text when an item is selected
    },
    escapeMarkup: function (markup) {
      return markup; // Allow raw HTML
    },
  });

  // Fetch options on initialization if fetch-on-init is true
  if (fetchOnInit && isAjax) {
    //fetchOptionsForSelect2($selectElement, apiEndpoint, "");
  }

  // Selection count update function
  function updateSelectionCount() {
    if (selectionCountId) {
      const count = $selectElement.val().length || 0;
      $(`#${selectionCountId}`).text(count);
    }
  }

  // Update selection count on change
  $selectElement.on("change", function () {
    updateSelectionCount();
  });

  // Initial call to set count for pre-selected items
  updateSelectionCount();
}

// Helper function to fetch options for Select2 on initialization
function fetchOptionsForSelect2($selectElement, apiEndpoint, searchTerm) {
  $.ajax({
    url: apiEndpoint,
    method: "GET",
    data: { search: searchTerm },
    success: function (data) {
      data = JSON.parse(data);
      console.log(data); // Log the response for debugging

      // Check if data exists and is an array
      if (data && Array.isArray(data)) {
        const newOptions = data.map(
          (item) => new Option(item.text, item.id, false, false)
        );

        // Append new options to the Select2 element
        $selectElement.append(newOptions).trigger("change");
      } else {
        console.error(
          "Invalid data format: 'data' is missing or not an array.",
          data
        );
      }
    },
    error: function () {
      console.error("Failed to fetch options for Select2.");
    },
  });
}

function initializeSortableSection(containerSelector) {
  const container = $(containerSelector);

  if (container.length > 0) {
    function updateIndices() {
      container.find(".sortable-item-row").each(function (index) {
        $(this).attr("data-index", index);

        // Update each input/select within the row
        $(this)
          .find("input, select")
          .each(function () {
            const $element = $(this);

            // Update `name` attribute to reflect the new index
            const name = $element.attr("name");
            if (name) {
              const updatedName = name.replace(/\[\d+\]/, `[${index}]`);
              $element.attr("name", updatedName);
            }

            // Update data-range-start and data-range-end attributes for date range fields
            if ($element.hasClass("phase-start-date")) {
              const newEndId = `endDate_${$(this)
                .closest(".sortable-item-row")
                .data("type")}_${index}`;
              $element.attr("data-range-end", newEndId);
              $element.attr(
                "id",
                `startDate_${$(this)
                  .closest(".sortable-item-row")
                  .data("type")}_${index}`
              );
            }

            if ($element.hasClass("phase-end-date")) {
              const newStartId = `startDate_${$(this)
                .closest(".sortable-item-row")
                .data("type")}_${index}`;
              $element.attr("data-range-start", newStartId);
              $element.attr(
                "id",
                `endDate_${$(this)
                  .closest(".sortable-item-row")
                  .data("type")}_${index}`
              );
            }
          });
      });
    }

    // Add new row
    container.on("click", ".sortable-item-add", function (event) {
      event.stopPropagation();
      const originalRow = container.find(".sortable-item-row:first");
      const currentRow = $(this).closest(".sortable-item-row");

      // Remove any existing Select2 instances in the original row
      originalRow.find(".choicesInput").each(function () {
        if ($(this).data("select2")) {
          $(this).select2("destroy");
        }
      });

      const newRow = originalRow.clone();

      // Clear input values in the cloned row
      newRow.find("input").val("");

      // Clear selections in the select elements for the cloned row
      newRow.find("select.choicesInput").each(function () {
        $(this).val(null); // Clear the selection
      });

      // Remove labels in the cloned row
      newRow.find("label").remove();

      // Insert the cloned row after the current row
      currentRow.after(newRow);

      // Reinitialize Select2 for the original row and the new row
      originalRow.find(".choicesInput").each(function () {
        $(this).select2(); // Reinitialize Select2 for the original row
      });
      newRow.find(".choicesInput").each(function () {
        $(this).select2(); // Initialize Select2 for the new row
      });

      updateIndices();
      initFlatPicker();
    });

    // Remove row
    container.on("click", ".sortable-item-remove", function () {
      const rows = container.find(".sortable-item-row");

      if (rows.length > 1) {
        const removedRow = $(this).closest(".sortable-item-row");
        const isFirstRow = removedRow.is(rows.first());

        // Remove the row
        removedRow.remove();

        // Update indices for remaining rows
        updateIndices();

        // If the removed row was the first row, add labels to the new first row
        if (isFirstRow) {
          addLabelsToFirstRow();
        }
      }
    });

    // Move row up
    container.on("click", ".sortable-item-sort-up", function () {
      const row = $(this).closest(".sortable-item-row");
      row.prev(".sortable-item-row").before(row);

      updateIndices();
      manageLabelsAfterMovement();
    });

    // Move row down
    container.on("click", ".sortable-item-sort-down", function () {
      const row = $(this).closest(".sortable-item-row");
      row.next(".sortable-item-row").after(row);

      updateIndices();
      manageLabelsAfterMovement();
    });

    // Function to add labels to the first row (excluding hidden fields)
    function addLabelsToFirstRow() {
      const firstRow = container.find(".sortable-item-row").first();

      // Target only visible inputs, selects, and textareas within the first row
      firstRow
        .find("input:visible, select:visible, textarea:visible")
        .each(function () {
          const $field = $(this);
          if ($field.is("button")) return;

          let label = $field.attr("placeholder") || $field.data("placeholder");

          // Only add a label if there isn't one already and if there is label text
          if (label && !$field.prev("label").length) {
            $field.before(`<label>${label}</label>`);
          }
        });
    }

    // Function to remove labels from non-first rows
    function removeLabelsFromOtherRows() {
      container.find(".sortable-item-row").not(":first").find("label").remove();
    }

    // Function to manage labels after any movement
    function manageLabelsAfterMovement() {
      removeLabelsFromOtherRows();
      addLabelsToFirstRow();
    }

    // Initial label setup on page load
    addLabelsToFirstRow();
    removeLabelsFromOtherRows();

    updateIndices(); // Initial call to set indices on load
  }
}
